<template>
    <div>
        <div class="px-3">
            <div id="div-modal-cxc" class="d-flex justify-content-center mt-4">
                <div id="div-cxc" class="card w-100 mb-lg-5 text-center">
                    <div class="card-header text-white bg-main h4">
                        <div style="position: relative;">
                            <div class="">
                                <strong>ORDENES DE TRABAJOS</strong>
                            </div>
                            <div class="btn-home-jefatura" style="right: 0;top: 0;position: absolute;">
                                <button type="button" class="btn btn-sm" @click="returnHome">
                                    <i class="fas fa-home-lg-alt"></i> Inicio
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body w-100">
                        <div class="row">
                            <div class="col-md-12 py-2">
                                <div class="row mx-0">
                                   
                                </div>
                            </div>
                            <div class="col-md-12" id="content-timelinetable">
                                <table id="tb-cxc" class="table table-bordered border-main text-xs">
                                    <caption class="py-0 my-0"></caption>
                                    <thead>
                                        <tr class=" text-center text-white border-white bg-main">
                                            <th scope="col">#</th>
                                            <th scope="col">N° DE OT</th>
                                            <th scope="col">FECHA DE REGISTRO</th>
                                            <th scope="col">DOCTOR</th>
                                            <th scope="col">PACIENTE</th>
                                            <th scope="col">TOTAL</th>
                                            <th scope="col">PAGADO</th>
                                            <th scope="col">PENDIENTE</th>
                                            <th scope="col" class="table-th-acciones">ESTADO</th>
                                            <th scope="col" class="table-th-acciones">FACTURA</th>
                                            <th scope="col" class="table-th-acciones">ACCION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="cpData.length === 0">
                                            <td class="text-center align-middle" colspan="11">Sin OT Registradas</td>
                                        </tr>
                                        <tr v-for="(item, index) in cpData" :key="index" class="font-size">
                                            <td class="text-center align-middle">
                                                {{ mtdNumber(index) }}
                                            </td>
                                            <td class="text-center align-middle">
                                                OT-{{ item.id.toString().padStart(6, '0') }}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ item.date }}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ item.doctor ? item.doctor.name+ ' '+ item.doctor.last_name : '-'}}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ item.patient ? item.patient.name  : '-'}}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ item.total}}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ item.amount}}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ item.pending}}
                                            </td>
                                            <td class="text-center align-middle">
                                                <div id="state_speciality" v-if="item.state == 1">
                                                    <div class="bg-danger text-white">Sin Pago</div>
                                                </div>
                                                <div id="state_speciality" v-if="item.state == 2">
                                                    <div class="bg-warning text-white">Pago Parcial</div>
                                                </div>
                                                <div id="state_speciality" v-if="item.state == 3">
                                                    <div class="bg-success text-white">Pagado y Canjeado</div>
                                                </div>
                                            </td>
                                            <td class="text-center align-middle">
                                                <div id="state_speciality" v-if="item.status == 1">
                                                    <div class="bg-danger text-white">Sin Factura</div>
                                                </div>
                                                <div id="state_speciality" v-if="item.status == 2">
                                                    <div class="bg-danger text-white">Sin Factura</div>
                                                </div>
                                                <div id="state_speciality" v-if="item.status == 3">
                                                    <div class="bg-success text-white">Con Factura</div>
                                                </div>
                                            </td>
                                            <td class="text-center align-middle">
                                                <div  v-if="item.status != 3" class="text-center d-flex justify-content-center">
                                                    <button class="btn btn-sm btn-info text-white mx-1" @click="mtdaddfactura(item)" >
                                                        <i class="far fa-file-invoice-dollar"></i>
                                                    </button>
                                                </div>
                                                <div  v-if="item.status == 3" class="text-center d-flex justify-content-center">
                                                    <button class="btn btn-sm  btn-warning mx-1" @click="mtdaddReport(item)" >
                                                        <i class="fas fa-file-invoice"></i>
                                                    </button>
                                                    <button v-if="item?.bills?.[0]?.file" class="btn btn-sm btn-success mx-1" @click="openPdf(item)">
                                                        <i class="fas fa-file"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="cpData.length > 0" class="d-flex justify-content-center px-3 mt-3">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination mb-1">
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)"
                                                @click="backPage">Anterior</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'"
                                                href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>

                                        <li v-for="(item, index) in limitedStepPagination" :key="index"
                                            class="page-item">
                                            <a :class="selectPage === item ? 'page-link active' : 'page-link'"
                                                href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                            </a>
                                        </li>
                                        <li v-if="limitedStepPagination[limitedStepPagination.length - 1] < stepPagination.length - 1"
                                            class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li v-if="limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length"
                                            class="page-item">
                                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active' : 'page-link'"
                                                href="javascript:void(0)"
                                                @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)"
                                                @click="nextPage">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <SweetAlert :swal="swal" ref="SweetAlert" />
        <cModalGenerarFactura
            :title="modalStoreBill.title"
            :boo_modal="modalStoreBill.modal_form"
            @closeModalStoreBill="closeModalStoreBill"
            :patient="patient"
            :dataMont="montura"
            :far="far"
            :near="near"
            :work_id="work_id"
            @add_exit="mtdGetData"
        />
        <cModalReportWork
            :title="modalReport.title"
            :boo_modal="modalReport.modal_form"
            @closeModalReport="closeModalReport"
            :tabla="tabla"
            :patient="patient"
           
        />
    </div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalGenerarFactura from "../modal/cModalGenerarFactura.vue";
import cModalReportWork from "../modal/cModalReportWork.vue";
export default {
    name: "c-gerencia-permisoLogistica",
    components: {
        SweetAlert,
        cModalGenerarFactura,
        cModalReportWork
    },
    data() {
        return {
            search: "",
            dataShow: [],
            data: [],
            filter: {
                init: null,
                end: null,
            },
           
            //Pag
            totalPagesToShow: 10,
            page: 0,
            selectPage: 1,
            stepPagination: [],
            swal: null,
            modalStoreBill: {
                title: "",
                modal_form: false,
            },
            modalReport: {
                title: "",
                modal_form: false,
            },
            patient:{},
            montura:[],
            far:{},
            near:{},
            work_id:0,
            tabla:[],
            near_plantilla: {
                    "od": null,
                    "oi": null,
                    "note": null,
                    "lensType": null,
                    "lensType_id": null,
                    "lensType_price": 0
                },
            far_plantilla:{
                "od": null,
                "oi": null,
                "note": null,
                "lensType": null,
                "lensType_id": null,
                "lensType_price": 0
            }


        };
    },
    watch: {
        selectPage() {
            this.calculateData(10);
        },

    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                length: endPage - startPage + 1,
            },
                (_, i) => startPage + i
            );
        },

    },
    created() {
        moment.locale("es");
        this.filter.end =
        moment().format("L").substr(6, 4) +
        "-" +
        moment().format("L").substr(3, 2) +
        "-" +
        moment().format("L").substr(0, 2);
        this.filter.init = this.filter.end;
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdGetData: function () {
            this.get({
                url: this.$store.getters.get__url + "/ordenTrabajo/workOrder/"+ this.$store.getters.get__campus,
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.data = response.data;
                this.calculateData(10);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        calculateData(items) {
            let filteredData = this.data;
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                length: totalPages,
            },
                (_, index) => index + 1
            );
            let startIndex = (this.selectPage - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
        },

        mtdaddfactura: function (payload) {
            this.modalStoreBill =  {
                title: "Generar Factura",
                modal_form: true,
            }
            this.patient = payload.patient;
            let montura = JSON.parse(payload.mounts);
            /* montura.forEach(element => {
                element.sub_id = null;
                element.barcode = '';
                element.price_cost = 0;
            }); */
            this.work_id  = payload.id;
            this.montura = montura;
          
            let far = typeof payload.far === "string" ? JSON.parse(payload.far) : payload.far;
            if (JSON.stringify(far) !== JSON.stringify(this.far_plantilla)) {
                far.price_cost = 0;
                this.far = far
            }else{
                this.far = null
            }


            let near = typeof payload.near === "string" ? JSON.parse(payload.near) : payload.near;
            if (JSON.stringify(near) !== JSON.stringify(this.near_plantilla)) {
                near.price_cost = 0;
                this.near = near;
            }else{
                this.near = null;
            }
            
        },

        closeModalStoreBill: function(){
            this.modalStoreBill =  {
                title: "",
                modal_form: false,
            }
        },
        mtdaddReport: function (payload) {
            this.tabla = [];
            let bill = payload.bills[0];

            let montura = JSON.parse(bill.mounts);

            const addToTable = (detalle, monto, price_cost) => {
                this.tabla.push({
                    'date_order': payload.date,
                    'order': payload.id,
                    'detalle': detalle,
                    'monto': parseFloat(monto).toFixed(2),
                    'proveedor': bill.proveedor.name,
                    'date_factura': bill.date,
                    'numb_factura': bill.number_bill,
                    'price_cost': parseFloat(price_cost).toFixed(2),
                    'utilidad_neta': (monto - price_cost).toFixed(2)
                });
            };

            // Procesar Monturas
            montura.forEach(element => {
                addToTable(element.mount_name, element.mount_price, element.price_cost);
            });

            // Procesar Far y Near
            ['far', 'near'].forEach(type => {
                let item = typeof bill[type] === "string" ? JSON.parse(bill[type]) : bill[type];
                if (item) {
                    addToTable(item.lensType, item.lensType_price, item.price_cost);
                }
            });
            console.log(this.tabla)
            this.modalReport = {
                title: "Reporte de Orden de Trabajo",
                modal_form: true,
            };
            this.patient = payload.patient;
        },


        closeModalReport: function(){
            this.modalReport =  {
                title: "",
                modal_form: false,
            }
        },

        openPdf: function (url) {
            console.log(url)
            let nuevaUrl = "/assets/" + url.bills[0].file;
            window.open(nuevaUrl, '_blank');
        },
        //Paginado
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                    this.selectPage + 1 :
                    this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        returnHome: function () {
            this.$emit("returnHome");
        },
        mtdChangeView: function (option) {
            this.$emit("mtdChangePage", option);
        },
        mtdNumber: function (index) {
            return (this.selectPage - 1) * 10 + (index + 1)
        },
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatDateTime(dateTime) {
            return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
        },
    },
}
</script>
<style>
.font-size{
    font-size: 13px !important;
}
.align-middle {
    vertical-align: middle;
}
</style>
